export const addDotBtnsAndClickHandlers = (
	instance,
	dotsNode,
	clickableDots = true,
	onButtonClick
) => {

	if (!dotsNode) return () => {}

	let dotNodes = []

	const addDotBtnsWithClickHandlers = () => {
		dotsNode.innerHTML = instance
			.scrollSnapList()
			.map((d, i) => clickableDots 
				? `<button type="button" class="embla__dot"><span class="u-sr-only">Slide ${i + 1}</span></button>` 
				: `<span class="embla__dot"><span class="u-sr-only">Slide ${i + 1}</span></span>`
			)
			.join('')

		const scrollTo = (index) => {
			instance.scrollTo(index)
			if (onButtonClick) onButtonClick(instance)
		}

		dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))

		if (clickableDots) {
			dotNodes.forEach((dotNode, index) => {
				dotNode.addEventListener('click', () => scrollTo(index), false)
			})
		}
	}

	const toggleDotBtnsActive = () => {
		const previous = instance.previousScrollSnap()
		const selected = instance.selectedScrollSnap()
		dotNodes[previous].classList.remove('embla__dot--selected')
		dotNodes[selected].classList.add('embla__dot--selected')
	}

	instance
		.on('init', addDotBtnsWithClickHandlers)
		.on('reInit', addDotBtnsWithClickHandlers)
		.on('init', toggleDotBtnsActive)
		.on('reInit', toggleDotBtnsActive)
		.on('select', toggleDotBtnsActive)

	return () => {
		dotsNode.innerHTML = ''
	}
}

export const setupProgressBar = (emblaApi, progressNode) => {

	const applyProgress = () => {
		const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()))
		progressNode.style.transform = `translate3d(${progress * 100}%,0px,0px)`
	}

	const removeProgress = () => {
		progressNode.removeAttribute('style')
	}

	return {
		applyProgress,
		removeProgress
	}
}

const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
	const togglePrevNextBtnsState = () => {
		if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled')
		else prevBtn.setAttribute('disabled', 'disabled')

		if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled')
		else nextBtn.setAttribute('disabled', 'disabled')
	}

	emblaApi
		.on('select', togglePrevNextBtnsState)
		.on('init', togglePrevNextBtnsState)
		.on('reInit', togglePrevNextBtnsState)

	return () => {
		prevBtn.removeAttribute('disabled')
		nextBtn.removeAttribute('disabled')
	}
}

export const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
	const scrollPrev = () => {
		emblaApi.scrollPrev()
	}
	const scrollNext = () => {
		emblaApi.scrollNext()
	}
	prevBtn.addEventListener('click', scrollPrev, false)
	nextBtn.addEventListener('click', scrollNext, false)

	const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
		emblaApi,
		prevBtn,
		nextBtn
	)

	return () => {
		removeTogglePrevNextBtnsActive()
		prevBtn.removeEventListener('click', scrollPrev, false)
		nextBtn.removeEventListener('click', scrollNext, false)
	}
}